var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react'; // tslint:disable-line

import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('icon');
import { breakpoints, theme } from '@shapeable/theme';
export var IconDefaultProps = {
  color: 'dark',
  ratio: 1
}; // -------- Styles -------->

var sizeIsNumber = function sizeIsNumber(size) {
  return typeof size === 'number';
};

var sizeFor = function sizeFor(breakpoint) {
  return function (props) {
    if (sizeIsNumber(props.size)) {
      return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n    "])), props.ratio * props.size, props.size);
    }
  };
};

var fill = function fill(props) {
  return props.color && props.color !== 'none' && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), theme.FILL(props.color));
};

var IconStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n    ", "\n    display: flex;\n    align-items: center;\n    svg {\n      width: 100%;\n      height: 100%;\n    }\n  "], ["\n    ", "\n    ", "\n    display: flex;\n    align-items: center;\n    svg {\n      width: 100%;\n      height: 100%;\n    }\n  "])), fill, sizeFor('base')),
  landscape: sizeFor('base'),
  tablet: sizeFor('tablet'),
  desktop: sizeFor('desktop'),
  desktopLarge: sizeFor('desktop-large')
}); // -------- Icons -------->

var My = {
  Container: styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
export var Icon = function Icon(props) {
  var children = props.children,
      className = props.className,
      size = props.size,
      type = props.type,
      color = props.color,
      style = props.style,
      component = props.component,
      ratio = props.ratio,
      onClick = props.onClick,
      title = props.title,
      rest = __rest(props, ["children", "className", "size", "type", "color", "style", "component", "ratio", "onClick", "title"]);

  var handleClick = onClick ? function (e) {
    e.stopPropagation();
    onClick(e);
  } : null; // @ts-ignore

  var SVG = component && (Icons[component] || Icons[component.replace(/Icon$/, '')]);
  return React.createElement(My.Container, __assign({}, rest, {
    style: style,
    title: title,
    onClick: handleClick,
    ratio: ratio,
    size: size,
    type: type,
    color: color,
    className: cls.name(className)
  }), children);
};
Icon.defaultProps = IconDefaultProps;
Icon.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;